import moment from 'moment-timezone'
import {
  processStatusVal, reportStatusVal, SERVICE_STATUS, servicesStatusVal, ticketStatusVal, ticketPriorityVal
} from './constants'
import { getRoleName } from '../services/roles'

moment.locale('es')
moment.tz.setDefault('America/Bogota')

const defaultFormat = 'dddd DD [de] MMMM hh:mm a, YYYY'

export function getTodayFormat () {
  return (format) => moment().format(format || defaultFormat)
};

export function formatDate () {
  return (date, format) => {
    return moment(date).format(format || defaultFormat)
  }
};

export function formatDateUTC () {
  return (date, format) => {
    return moment(date).utc().format(format || defaultFormat)
  }
};

export function getProcessStatus () {
  return (status) => {
    const find = processStatusVal.find(
      (processStatus) => processStatus.value === status
    )
    return !find ? status : find.text
  }
};

export function getServiceStatus () {
  return (status) => {
    const find = servicesStatusVal.find(
      (serviceStatus) => serviceStatus.value === status
    )
    return !find ? status : find.text
  }
};

export function getError () {
  return (status) => {
    switch (status) {
      case 400:
        return 'error'
      case 401:
        return 'warning'
      default:
        return 'info'
    }
  }
};

export function firstUpper () {
  return str => str.charAt(0).toUpperCase() + str.slice(1)
};

export function getStatusService () {
  return (service) => ({
    'green--text text--darken-4': service.status === SERVICE_STATUS.APPROVED,
    'red--text': service.status === SERVICE_STATUS.NOT_APPROVED,
    'gray--text text--darken-2': service.status === SERVICE_STATUS.IN_PROGRESS,
    'gray--text':
      service.status === SERVICE_STATUS.PENDING ||
      service.status === SERVICE_STATUS.ASSIGNED,
    'text-decoration-line-through': service.status === SERVICE_STATUS.CANCELLED
  })
};

export function getRolName () {
  return (rol) => getRoleName(rol)
};

export function getReportStatus () {
  return (status) => {
    const find = reportStatusVal.find((reportStatus) => reportStatus.value === status)
    return find ? find.text : ''
  }
};

export function getReportStatusColor () {
  return (status) => {
    const find = reportStatusVal.find((reportStatus) => reportStatus.value === status)
    return find ? find.color : 'info'
  }
};

// XAN-24 — gestor de tickets internos.
export function getTicketStatus () {
  return (status) => {
    const find = ticketStatusVal.find((ticketStatus) => ticketStatus.value === status)
    return find ? find.text : status
  }
};

export function getTicketStatusColor () {
  return (status) => {
    const find = ticketStatusVal.find((ticketStatus) => ticketStatus.value === status)
    return find ? find.color : 'grey'
  }
};

export function getTicketPriority () {
  return (priority) => {
    const find = ticketPriorityVal.find((ticketPriority) => ticketPriority.value === priority)
    return find ? find.text : priority
  }
};

export function getTicketPriorityColor () {
  return (priority) => {
    const find = ticketPriorityVal.find((ticketPriority) => ticketPriority.value === priority)
    return find ? find.color : 'grey'
  }
};

export function getTicketPriorityIcon () {
  return (priority) => {
    const find = ticketPriorityVal.find((ticketPriority) => ticketPriority.value === priority)
    return find ? find.icon : 'mdi-minus'
  }
};

export function getStatusServiceChip () {
  return (status) => {
    switch (status) {
      case SERVICE_STATUS.APPROVED:
        return 'green'
      case SERVICE_STATUS.NOT_APPROVED:
        return 'red'
      case SERVICE_STATUS.IN_PROGRESS:
        return 'grey'
      case SERVICE_STATUS.CANCELLED:
        return 'grey'
      default:
        return 'info'
    }
  }
};

// XAN-196 — concept a process is grouped under in the invoice summary. When a combo has
// cancelled services the billed one is what was actually performed: the backend resolves its
// name into metadata.comboName, and the active service names are the fallback.
export const getInvoiceConcept = (process) => {
  const [service] = process.serviceByProcess

  if (!service.groupId) {
    return { name: service.name, total: service.value }
  }

  const active = process.serviceByProcess.filter(
    (item) => item.status !== SERVICE_STATUS.CANCELLED
  )

  if (active.length === process.serviceByProcess.length) {
    return { name: service.groupName, total: service.groupTotal }
  }

  const name =
    process.metadata?.comboName ||
    (active.length ? active.map((item) => item.name).join(' + ') : 'Otros Servicios')

  return { name, total: process.total }
}

export const formatToTwoDecimals = (num) => {
  if (typeof num !== 'number' && isNaN(parseFloat(num))) {
    throw new Error('El valor proporcionado debe ser un número válido.')
  }

  if (Number.isInteger(num)) {
    return num
  }

  return parseFloat(num).toFixed(2)
}
